/**
 * 应用中心limit设置模块
 */
export const ApplypageLimit = [
  {
    path: "pageLimit",
    name: "pageLimit",
    meta: {
      title: "limit"
    },
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "oilsListNow",
        name: "oilsListNow",
        meta: {
          title: "当前班次订单"
        },
        component: () => import("@/views/apply/newVip/order/oilsListNow")
      },
      {
        path: "getMoney",
        name: "getMoney",
        meta: {
          title: "收银消费"
        },
        component: () =>
          import("@/views/apply/newVip/business/charging/getMoney")
      },
      {
        path: "oilsList",
        name: "oilsList",
        meta: {
          title: "油品订单"
        },
        component: () => import("@/views/apply/newVip/order/oilsList")
      },
      {
        path: "changeDuty",
        name: "changeDuty",
        meta: {
          title: "交班"
        },
        component: () => import("@/views/apply/newVip/home/changeDuty")
      },
      {
        path: "changeDutyDetail",
        name: "changeDutyDetail",
        meta: {
          title: "交班"
        },
        component: () => import("@/views/apply/newVip/home/changeDutyDetail")
      },
      {
        path: "changeDutyList",
        name: "changeDutyList",
        meta: {
          title: "交班记录"
        },
        component: () => import("@/views/apply/newVip/home/changeDutyList")
      },
      {
        path: "royalties",
        name: "royalties",
        meta: {
          title: "员工提成"
        },
        component: () => import("@/views/apply/newVip/home/commission")
      },
      {
        path: "royaltiesSet",
        name: "royaltiesSet",
        meta: {
          title: "员工提成"
        },
        component: () => import("@/views/apply/newVip/home/royalties")
      },
      {
        path: "royaltiesSet1",
        name: "royaltiesSet1",
        meta: {
          title: "员工提成"
        },
        component: () => import("@/views/apply/newVip/home/commissionSet")
      },
      {
        path: "changeDutyNew",
        name: "changeDutyNew",
        meta: {
          title: "交班"
        },
        component: () => import("@/views/apply/newVip/home/changeDutyNew")
      },
      {
        path: "changeDutyNew2",
        name: "changeDutyNew2",
        meta: {
          title: "交班"
        },
        component: () => import("@/views/apply/newVip/home/changeDutyNew2")
      },
      {
        path: "voucherList",
        name: "voucherList",
        meta: {
          title: "充值订单"
        },
        component: () => import("@/views/apply/newVip/order/voucherList")
      },
      {
        path: "ordinaryList",
        name: "ordinaryList",
        meta: {
          title: "普通订单"
        },
        component: () => import("@/views/apply/newVip/order/ordinaryList")
      },
      {
        path: "shellIntegral",
        name: "shellIntegral",
        meta: {
          title: "积分兑换"
        },
        component: () =>
          import("@/views/apply/comModule/integralMall/order/index.vue")
      },
      {
        path: "recharge",
        name: "recharge",
        meta: {
          title: "快速充值"
        },
        component: () =>
          import("@/views/apply/newVip/business/charging/recharge")
      },
      {
        path: "integral",
        name: "integral",
        meta: {
          title: "会员积分"
        },
        component: () =>
          import("@/views/apply/newVip/business/charging/integral")
      },
      {
        path: "scanVerification",
        name: "scanVerification",
        meta: {
          title: "现金待确认"
        },
        component: () => import("@/views/apply/newVip/home/scanVerification")
      },
      {
        path: "userList",
        name: "userList",
        meta: {
          title: "客户列表"
        },
        component: () => import("@/views/apply/newVip/user/userList.vue")
      }
    ]
  }
];
